import * as api from 'service/ErplyAPI/auth';
import {
  CLIENT_CODE,
  SESSION_KEY,
  USERNAME,
  USER_TOKEN,
  EMPLOYEE_ID,
} from 'utils/constants';
import history from 'utils/history';
import { addError } from 'rdx/alert';
import { navigateToLogin } from 'utils';

import { getAuthEndpoint } from '../config';

import * as c from './types';

export const login = (credentials) => async (dispatch) => {
  dispatch({ type: c.LOGIN.START });
  try {
    localStorage.setItem(CLIENT_CODE, credentials.clientCode);
    const data = await api.login(credentials);
    const [user] = data.records;
    localStorage.setItem(SESSION_KEY, user.sessionKey);
    localStorage.setItem(USERNAME, user.userName);
    localStorage.setItem(EMPLOYEE_ID, user.employeeID);
    dispatch({ type: c.LOGIN.SUCCESS, payload: user });
    history.push('/');
  } catch (err) {
    dispatch(
      addError(err.message, {
        dismissible: true,
        selfDismiss: true,
        alertType: 'info',
      }),
    );
    dispatch({ type: c.LOGIN.ERROR, payload: err.message });
  }
};
const initSessionFromCookie = async () => {
  const clientCode =
    new URLSearchParams(window.location.search).get('clientCode') ??
    localStorage.getItem(CLIENT_CODE);
  if (!clientCode)
    throw new Error('No clientcode in query params or localStorage');

  const {
    records: [credentials],
  } = await api.cookieLogin({ clientCode });
  if (!credentials) throw new Error('Could not authenticate existing session');

  localStorage.setItem(CLIENT_CODE, clientCode);
  localStorage.setItem(USERNAME, credentials.userName);
  localStorage.setItem(EMPLOYEE_ID, credentials.employeeID);
  localStorage.setItem(SESSION_KEY, credentials.sessionKey);
  localStorage.setItem(USER_TOKEN, credentials.identityJWT);
};
export const initSession = () => async (dispatch) => {
  dispatch({ type: c.INIT_SESSION.START });
  try {
    await initSessionFromCookie();
    dispatch({ type: c.INIT_SESSION.SUCCESS, payload: {} });
  } catch (err) {
    console.error(err);
    localStorage.removeItem(CLIENT_CODE);
    localStorage.removeItem(USERNAME);
    localStorage.removeItem(EMPLOYEE_ID);
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem(USER_TOKEN);
    dispatch({ type: c.INIT_SESSION.ERROR, payload: err.message });
    throw err;
  }
};

export const logout = () => async (dispatch) => {
  dispatch({ type: c.LOGOUT.START });
  const clientCode = localStorage.getItem(CLIENT_CODE);
  const sessionKey = localStorage.getItem(SESSION_KEY);
  try {
    await api.logout({
      clientCode,
      authURL: getAuthEndpoint().url,
      sessionKey,
    });
    navigateToLogin();
  } catch (e) {
    dispatch({ type: c.LOGOUT.ERROR });
  } finally {
    localStorage.removeItem(CLIENT_CODE);
    localStorage.removeItem(USERNAME);
    localStorage.removeItem(EMPLOYEE_ID);
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem(USER_TOKEN);
  }
};

